module.exports = (window.WeakMap.WeakMap = window.WeakMap);